import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core'
declare interface RouteInfo {
  text: string
  text2: string
}
export const CaliforniaBusinessPolicySummitContent: RouteInfo[] = [
  {
    text:
      "The California Hispanic Chambers of Commerce annual Business Policy Summit is the premier legislative and policy event for California's diverse small business communities to engage in the key issues impacting the growth of California's economy.",
    text2:
      "The Summit encourages the use of our collective voices to advance policy issues for California's diverse small businesses and Hispanic community. Participants will participate in issue briefings and engage with the legislature, policymakers, thought leaders, and Sacramento insiders while gaining in-person perspectives on policy and legislative processes.",
  },
]

@Component({
    selector: 'app-california-business-policy-summit',
    templateUrl: './california-business-policy-summit.component.html',
    styleUrls: ['./california-business-policy-summit.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CaliforniaBusinessPolicySummitComponent implements OnInit {
  mainTitle = 'California Business Policy Summit'
  texts: any = []
  constructor() {}

  ngOnInit(): void {
    this.texts = CaliforniaBusinessPolicySummitContent.filter((text) => text)
  }
}
